import { type FC } from "react";
import BoxForm from "../../Common/BoxForm/BoxForm";
import { useTitle } from "../../Utilities/TitleHook";
import { PartnerRegistrationBackground } from "./PartnerRegistrationBackground";

const PartnerRegistered: FC = () => {
    useTitle("Partner Registration");

    return (
        <main>
            <PartnerRegistrationBackground />
            <BoxForm>
                <h1>Partner Registration</h1>
                <p>
                    Thank you for taking the time to register,
                    we&apos;ll be in touch shortly.
                </p>
                <p>
                    If you have any questions, feel free to reach out
                    to us at api@shopfront.com.au.
                </p>
            </BoxForm>
        </main>
    );
};

export default PartnerRegistered;
